module.exports = __webpack_public_path__ + "public/adminIcons/last-30days-users.png?4b755430";